import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FormServicesFactory} from '../Services/factory.js'
import {SearchUrlFormValueObject} from '../ValueObjects/SearchUrlFormValueObject.js'

class GetSpecsFormUseCase extends UseCase {
  #config
  #specsFormService
  #searchUrlFormValueObject

  constructor({config}) {
    super()
    this.#config = config
    this.#searchUrlFormValueObject = SearchUrlFormValueObject
    this.#specsFormService = FormServicesFactory.getSpecsFormService({config: this.#config})
  }

  static create({config}) {
    return new GetSpecsFormUseCase({config})
  }

  @tracer({metric: 'GetSpecsFormUseCase#execute'})
  @AsyncInlineError()
  async execute({nextField = 'makes', params = {}} = {}) {
    const searchUrlVO = this.#searchUrlFormValueObject.fromNextFieldAndParamsToValueObject({
      config: this.#config,
      nextField,
      params
    })

    const [error, specsFormVOResponse] = await this.#specsFormService.execute({
      searchUrlVO
    })

    if (error) return Promise.reject(error)

    return specsFormVOResponse.toJSON()
  }
}

export const factory = GetSpecsFormUseCase.create
